module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.eot?6708c81cdf01cae30bb04c3c8a71d573";